var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteLabel = function SvgWhiteLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#white-label_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "M21.666 18.333 5.833 34.167m17.53-28.27a37.7 37.7 0 0 1 5.805 4.759 37.7 37.7 0 0 1 4.793 5.857M15.424 13.16l-4.791-1.597a1.67 1.67 0 0 0-1.604.309l-4.762 4.03a1.667 1.667 0 0 0 .5 2.835L9.28 20.4m10.188 10.187L21.13 35.1a1.667 1.667 0 0 0 2.836.5l4.03-4.761a1.67 1.67 0 0 0 .309-1.604l-1.598-4.791m5.54-20.659L24.07 5.147a4.07 4.07 0 0 0-2.305 1.235L10.743 18.164a7.754 7.754 0 0 0 10.96 10.96l11.782-11.022a4.07 4.07 0 0 0 1.235-2.304l1.363-8.178c.376-2.256-1.58-4.212-3.836-3.836"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "white-label_svg__a",
    x1: 33.25,
    x2: -31.607,
    y1: 4.634,
    y2: 29.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgWhiteLabel;